import React from "react";
import styles from "../../styles/Signup.module.scss";
import classnames from "classnames";
import GenericInput from "../../containers/helpers/genericInput";
import GenericDropdown from "../../containers/helpers/genericDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import countryList from "../../constants/country_list";

export default function ProfilePersonalInformation(props) {
  const {
    errorStateObject,
    handleFieldChange,
    updateErrorText,
    handleSubmit,
    inputStyles,
    profileContainerClass,
    updateStatus,
    updateSuccessful,
    changePasswordClicked,
    email,
    name,
    username,
    phone,
    country,
    screenName,
    currentScreenName,
    updateScreenNameSuccessful,
    screenNameError
  } = props;
  const countryArray = countryList.names;

  const BbworldCreatorHelperText = () => {
    return(
      <div>
        <p>
        Your Buildbox World Creator Name will be displayed when your <span styles={{fontWeight: "700"}}>Bit</span> is shared globally. 
        </p>
        <br/>
        <p >
        Creator Name must be 3-25 characters long.Only letters, numbers, dashes, periods, or underscores may be used. No other special characters are allowed."
        </p>
      </div>
    )
  }

  const ToolTip = ({text, children, direction}) => {

    // This sets the direction of tooltip based 
    const textStyle = classnames({
      [styles.tooltiptext]: true,
      [styles.tooltiptextTop]: direction === "top" ? true:false,
      [styles.tooltiptextBottom]: direction === "bottom" ? true:false,
      [styles.tooltiptextRight]: direction === "right" ? true:false,
      [styles.tooltiptextLeft]: direction === "left" ? true:false,
  
    });
    return (
      <div className={styles.tooltip}>
          {children}
        <div className={textStyle}>
              <p s>{text}</p> 
            </div>       
      </div>

    )
  }
  const screenNameTitle =  () => {
    return (
      <div className={styles.userCreatorNameInfoTitle}>
        <div style={{marginRight: 75}}>Buildbox World Creator Name:</div>
        <div>
        <ToolTip text={<BbworldCreatorHelperText/>} direction="bottom">
          <img className={styles.infoIcon} src="https://frontend-assets.buildbox.com/user_info_icon.svg" alt="info"/>
        </ToolTip>
        </div>
        {/* <abbr className={styles.abbr} title={hoverText} >
          <img className={styles.infoIcon} src="https://frontend-assets.buildbox.com/user_info_icon.svg" alt="info"/>
        </abbr> */}
      </div>
    )
  }

  const CreatorNameErrorText = () => {
    return (
      <div className={styles.errorMessage}>
        { screenNameError === 'ERROR_SCREEN_NAME_IN_USE'?  <div>This Creator Name is already taken. Please choose a different one.</div>: <>
          <div>Creator Name must: </div>
          <ul>
            <li>be 3-25 characters long</li>
            <li>only contain letters, numbers, dashes, periods, or underscores</li>
            <li>No profanity, swear words, or inappropriate words</li>
          </ul>
          </>
        }
      </div>
    )
  }
  return (
    <>
      {/* <div className={inputStyles.profileIcon}>
        <FontAwesomeIcon icon={faUser} />
      </div> */}
      <div className={profileContainerClass}>
        <div className={inputStyles.errorMessage}>
          <div>
          <span>{updateErrorText}</span>
          {updateErrorText && <FontAwesomeIcon icon={faExclamationTriangle} />}
          </div>
          <div>
          {/* <span>{screenNameError}</span> */}
          </div>
          
        </div>
        <div className={inputStyles.flexWrapper}>
          <GenericInput
            type={"text"}
            title={"Username:"}
            placeholder={"username"}
            inputName={"name"}
            inputValue={username}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            svg={"https://frontend-assets.buildbox.com/Icon_User.svg"}
            disabled
          />
          <GenericInput
            type={"text"}
            title={"Name:"}
            placeholder={"Name"}
            inputName={"name"}
            errorState={errorStateObject.name}
            inputValue={name}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            svg={"https://frontend-assets.buildbox.com/Icon_User.svg"}
          />
        </div>
        <div className={inputStyles.flexWrapper}>
          <GenericInput
            type={"email"}
            title={"Email:"}
            placeholder={"Email"}
            inputName={"email"}
            errorState={errorStateObject.email}
            inputValue={email}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            svg={"https://frontend-assets.buildbox.com/Icon_Email.svg"}
            disabled
          />
          <GenericInput
            type={"tel"}
            title={"Phone:"}
            placeholder={"Phone"}
            inputName={"phone"}
            errorState={errorStateObject.phone}
            inputValue={phone}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            svg={"https://frontend-assets.buildbox.com/Icon_Phone.svg"}
            disabled
          />
        </div>
        <div className={inputStyles.flexWrapper}>

        <GenericDropdown
          title={"Country: "}
          inputName={"country"}
          inputValue={country}
          listItemArray={countryArray}
          changeCallback={handleFieldChange}
          errorMessage={""}
          styles={{
            container: inputStyles.dropdownWrapper,
            errorMessage: inputStyles.dropdownErrorMessage,
          }}
          svg={"https://frontend-assets.buildbox.com/Icon_User.svg"}
          // disabled
        />
        <button
          onClick={changePasswordClicked}
          className={inputStyles.changePasswordBtn}
        >
          Change
        </button>
        <GenericInput
          type={"text"}
          // title={"Buildbox World Creator Name: "}
          title={screenNameTitle()}
          placeholder={currentScreenName}
          inputName={"screenName"}
          errorState={errorStateObject.screenName}
          inputValue={screenName}
          changeCallback={handleFieldChange}
          styles={inputStyles}
          svg={"https://frontend-assets.buildbox.com/Icon_User.svg"}
          maxLength={25}
          />
        </div>
        <div className={inputStyles.flexWrapper}>
          <GenericInput
            type={"password"}
            title={"Password:"}
            placeholder={"******"}
            inputName={"password"}
            errorState={errorStateObject.password}
            inputValue={""}
            changeCallback={handleFieldChange}
            styles={inputStyles}
            disabled
            svg={"https://frontend-assets.buildbox.com/Icon_Lock.svg"}
            />
          <div className={styles.screenNameMessageWrapper} >
            { updateScreenNameSuccessful && <div className={styles.screenNameSuccessText}>Congrats, you’ve successfully changed your Buildbox World Creator Name!</div>}
            { errorStateObject.screenName && <CreatorNameErrorText /> }
          </div>
          
        </div>
      </div>
      <div className={inputStyles.buttonContainer}>
        <button
          onClick={handleSubmit}
          // className={styles.updateBtn}
          className={inputStyles.submitButton}
        >
          Update
        </button>
        {updateSuccessful && (
          <div className={inputStyles.messages}>
            <span>{updateStatus}</span>
          </div>
        )}
      </div>
    </>
  );
}
